import {
  CredentialResponse,
  GoogleLogin,
  GsiButtonConfiguration,
} from "@react-oauth/google";
import { enqueueSnackbar } from "notistack";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { GOOGLE_AUTH_FAILED } from "../../constants";
import { login } from "../../services/apiV2";
import { GOOGLE_GENERIC_PASSWORD } from "../../constants/auth";
import { Box, Button, styled } from "@mui/material";
import GoogleIcon from "../../assets/google copy.png";

type TJWTGooglePayload = JwtPayload & {
  email: string;
  email_verified: boolean;
  given_name: string;
  family_name: string;
  picture: string;
  name: string;
};

type TGoogleAuthButtonProps = Partial<GsiButtonConfiguration>;

const CustomGoogleButton = styled(Button)(() => ({
  height: 40,
  border: "1px solid #dadce0",
  fontSize: 14,
  fontWeight: 500,
  color: "#646464",
  backgroundColor: "#FFFFFF",
  transition: "background-color .218s, border-color .218s",
  "&:hover": {
    backgroundColor: "rgba(66, 133, 244, 0.08)",
    borderColor: "rgb(210, 227, 252)",
  },
}));

export const GoogleAuthButton = ({ ...restProps }: TGoogleAuthButtonProps) => {
  const handleSuccess = async (credentialResponse: CredentialResponse) => {
    if (!credentialResponse.credential) {
      enqueueSnackbar(GOOGLE_AUTH_FAILED, { variant: "error" });
      return;
    }

    const decoded = jwtDecode<TJWTGooglePayload>(credentialResponse.credential);

    try {
      const res = await login({
        email: decoded.email,
        password: GOOGLE_GENERIC_PASSWORD,
        IsExternalLogin: true,
        GoogleSubId: decoded.sub,
        Provider: "google.com",
        fullName: decoded.name,
        GooglePicUrl: decoded.picture,
      });
    } catch {
      enqueueSnackbar(GOOGLE_AUTH_FAILED, { variant: "error" });
    }
  };

  const handleError = () => {
    enqueueSnackbar(GOOGLE_AUTH_FAILED, { variant: "error" });
  };

  return (
    <Box>
      <CustomGoogleButton
        fullWidth
        onClick={(e) => {
          const googleButton =
            e.currentTarget.nextElementSibling!.querySelector(
              '[role="button"]',
            ) as HTMLButtonElement | null;

          if (googleButton) {
            googleButton.click();
          }
        }}
        startIcon={
          <img src={GoogleIcon} alt="Google icon" width={18} height={18} />
        }
      >
        {restProps.text === "signup_with"
          ? "Sign up with Google"
          : "Sign in with Google"}
      </CustomGoogleButton>
      <Box display="none">
        <GoogleLogin
          useOneTap
          onSuccess={handleSuccess}
          onError={handleError}
          {...restProps}
        />
      </Box>
    </Box>
  );
};
